import axios from "../../axios-config";

export const getAllQuestions = async ({ page = 1, limit = 10 } = {}) => {
    const response = await axios.get(`/professoru/v1/forum/question?page=${page}&limit=${limit}`);
    return response?.data || { data: [], pagination: { total: 0, page, limit, totalPages: 0 } };
};

export const getCurrentUserQuestions = async ({ page = 1, limit = 10 } = {}) => {
    const response = await axios.get(`/professoru/v1/forum/question/user?page=${page}&limit=${limit}`);
    return response?.data || { data: [], pagination: { total: 0, page, limit, totalPages: 0 } };
};

export const getQuestionById = async (id) => {
    const response = await axios.get(`/professoru/v1/forum/question/${id}`);
    return response?.data || [];
};

export const searchQuestions = async ({ query, page = 1, limit = 10 } = {}) => {
    const response = await axios.get(`/professoru/v1/forum/question/search?search=${query}&page=${page}&limit=${limit}`);
    return response?.data || { data: [], pagination: { total: 0, page, limit, totalPages: 0 } };
};

export const postQuestion = async (body) => {
    const response = await axios.post(`/professoru/v1/forum/question`, body);
    return response?.data || {};
};

export const addReply = async (body) => {
    const response = await axios.post(`/professoru/v1/forum/question/reply`, body);
    return response?.data || {};
};

export const postQuestionReaction = async (body) => {
    const response = await axios.post(`/professoru/v1/forum/question/reactions`, body);
    return response?.data || {};
};

export const updateQuestionStatus = async (id, body) => {
    const response = await axios.put(`/professoru/v1/forum/question/${id}`, body);
    return response?.data || {};
};

export const deleteQuestion = async (body) => {
    const response = await axios.delete(`/professoru/v1/forum/question`, { data: body });
    return response?.data || {};
};

export const fetchAllRewards = async () => {
    const response = await axios.get(`/professoru/v1/rewards`);
    return response?.data || {};
};

export const rewardNotification = async (id, text) => {
    const encodedText = encodeURIComponent(text || '');
    const response = await axios.post(`/professoru/v1/rewards/${id}/${encodedText}/profile-view`);
    return response?.data || {};
};

export const claimReward = async (rewardId) => {
    const response = await axios.post(`/professoru/v1/rewards/${rewardId}/claim`);
    return response?.data || {};
};

export const fetchPendingRewardNotifications = async () => {
    const response = await axios.get(`/professoru/v1/rewards/notifications/pending`);
    return response?.data?.data || [];
};

export const markRewardNotificationsSeen = async (rewardIds = []) => {
    const response = await axios.post(`/professoru/v1/rewards/notifications/seen`, { rewardIds });
    return response?.data || {};
};